export default class EventConst {
  static SAVE = 'savingdata'
  static LOADING = 'load'
  static INTERACTION = 'interaction'
  static SHOWCOMPONENT = 'showcomp'
}
